// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardBanner-wrapper {
  width: 100%;
  min-height: 121px;
  border-radius: 8px;
  padding: 12px;
  margin: 20px 0;
  background: transparent;
  background: var(--banner-color, transparent);
  -webkit-print-color-adjust: exact;
     color-adjust: exact;
          print-color-adjust: exact;
}
.DashboardBanner-wrapper .DashboardBanner-content-wrapper {
  display: flex;
  flex-direction: row;
  min-height: 96px;
  padding: 20px 24px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ffffff 63.38%, rgba(255, 255, 255, 0.3882352941) 85.14%, rgba(255, 255, 255, 0) 95.56%);
}
.DashboardBanner-wrapper .DashboardBanner-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  max-width: 918px;
  max-height: 56px;
  container-type: inline-size;
  width: 100%;
}
.DashboardBanner-wrapper .DashboardBanner-content [class^=dist_noImage] {
  border-radius: 8px;
}
.DashboardBanner-wrapper .DashboardBanner-content img {
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #ccc;
}
.DashboardBanner-wrapper .DashboardBanner-svgWrapper {
  background-color: var(--color_neutral_500);
  border-radius: 13.45px;
  width: 62.788px;
  height: 62.788px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DashboardBanner-wrapper .DashboardBanner-svgWrapper svg {
  width: 38px !important;
  height: 38px !important;
}
.DashboardBanner-wrapper .DashboardBanner-textWrapper {
  display: flex;
  flex-direction: column;
}
.DashboardBanner-wrapper .DashboardBanner-subtitle {
  color: var(--color_neutral_800);
  font-size: 16px;
}
.DashboardBanner-wrapper .DashboardBanner-text {
  font-size: 32px;
  font-weight: 600;
  color: #000;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.DashboardBanner-wrapper .DashboardBanner-text strong {
  font-weight: 700;
}
@container (max-width: 500px) {
  .DashboardBanner-wrapper .DashboardBanner-text {
    font-size: 28px;
  }
}
@container (min-width: 500px) {
  .DashboardBanner-wrapper .DashboardBanner-text {
    font-size: 32px;
  }
}
.DashboardBanner-wrapper .DashboardBanner-powered-by {
  margin-left: auto;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  color: white;
  align-self: flex-end;
  max-height: 16px;
  padding-left: 20px;
}
.DashboardBanner-wrapper .DashboardBanner-powered-by span {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
.DashboardBanner-wrapper .DashboardBanner-powered-by svg {
  height: 16px;
  width: auto;
  padding-left: 6px;
}
.DashboardBanner-wrapper .DashboardBanner-powered-by svg path {
  fill: #ffffff;
}

.DashboardBanner-mobile {
  color: rgb(0, 0, 0);
  margin-left: -5px;
  font-size: 24px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/dashboard-banner/dashboard-banner.styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EAAA,4CAAA;EACA,iCAAA;KAAA,mBAAA;UAAA,yBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2HAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,WAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,kBAAA;EACA,iBAAA;EACA,sBAAA;AADN;AAKE;EACE,0CAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACE,sBAAA;EACA,uBAAA;AAHN;AAOE;EACE,aAAA;EACA,sBAAA;AALJ;AAQE;EACE,+BAAA;EACA,eAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAUI;EACE;IACE,eAAA;EARN;AACF;AAWI;EACE;IACE,eAAA;EATN;AACF;AAaE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AAXN;AAcI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAZN;AAcM;EACE,aAAA;AAZR;;AAkBA;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAfF","sourcesContent":[".DashboardBanner-wrapper {\n  width: 100%;\n  min-height: 121px;\n  border-radius: 8px;\n  padding: 12px;\n  margin: 20px 0;\n  background: var(--banner-color, transparent);\n  print-color-adjust: exact;\n\n  .DashboardBanner-content-wrapper {\n    display: flex;\n    flex-direction: row;\n    min-height: 96px;\n    padding: 20px 24px;\n    border-radius: 8px;\n    background: linear-gradient(90deg, #ffffff 63.38%, #ffffff63 85.14%, #ffffff00 95.56%);\n  }\n\n  .DashboardBanner-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    max-width: 918px;\n    max-height: 56px;\n    container-type: inline-size;\n    width: 100%;\n\n    [class^='dist_noImage'] {\n      border-radius: 8px;\n    }\n\n    img {\n      border-radius: 8px;\n      object-fit: cover;\n      border: 1px solid #ccc;\n    }\n  }\n\n  .DashboardBanner-svgWrapper {\n    background-color: var(--color_neutral_500);\n    border-radius: 13.45px;\n    width: 62.788px;\n    height: 62.788px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      width: 38px !important;\n      height: 38px !important;\n    }\n  }\n\n  .DashboardBanner-textWrapper {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .DashboardBanner-subtitle {\n    color: var(--color_neutral_800);\n    font-size: 16px;\n  }\n\n  .DashboardBanner-text {\n    font-size: 32px;\n    font-weight: 600;\n    color: #000;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n\n    strong {\n      font-weight: 700;\n    }\n\n    @container (max-width: 500px) {\n      & {\n        font-size: 28px;\n      }\n    }\n\n    @container (min-width: 500px) {\n      & {\n        font-size: 32px;\n      }\n    }\n  }\n\n  .DashboardBanner-powered-by {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 700;\n    color: white;\n    align-self: flex-end;\n    max-height: 16px;\n    padding-left: 20px;\n\n    span {\n      width: max-content;\n    }\n\n    svg {\n      height: 16px;\n      width: auto;\n      padding-left: 6px;\n\n      path {\n        fill: #ffffff;\n      }\n    }\n  }\n}\n\n.DashboardBanner-mobile {\n  color: rgb(0, 0, 0);\n  margin-left: -5px;\n  font-size: 24px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
